import { agentLook } from './looks';

import './styles/agent-face.css';

// The face of an agent.
//
// A DRAWING AND NOT A PHOTOGRAPH, on purpose: what is behind a token is a
// program acting for a person, and a human avatar would say the opposite of
// what the model says.
//
// It lives in `common/` because two features need it — the pulse's banner and
// the task board — and `features/a → features/b` is forbidden (TSS vite/01
// [RIGID]). It resolves nothing and fetches nothing: the state arrives as a
// prop, which is also what keeps the same face honest in both places.
//
// TWO AXES, AND THEY DO NOT SHARE INK.
//
//   kind   WHICH agent: the outline and the silhouette (see looks.js, where
//          each kind is customized). Optional — without it the face is neutral.
//   state  WHAT it is doing: the eyes, the bulb and the cells.
//
// FIVE STATES OUT OF ONE SHAPE. The markup does not change between them; only
// the classes do. A second avatar for the second state is a second avatar to
// keep in sync, and it drifts.
//
//   working  the reservation is alive — eyes and antenna lit, the three cells
//            filling left to right the way a progress bar does
//   live     the CREDENTIAL authenticates today: green, and still. Not the same
//            claim as `working` and that is why it does not beat — a token does
//            nothing, it is available. A face that pulsed just for existing
//            would say an agent is running when all that is true is that its
//            token works.
//   expired  it holds a reservation that ran out: awake, and about to lose it
//   idle     nothing in hand — the eyes close
//   plain    no claim about liveness at all, for a place that only needs to say
//            WHICH agent this is

export default function AgentFace({ state = 'plain', kind = null, size = 44, title }) {
    const look = agentLook(kind);

    const className = [
        'agent-face',
        `agent-face--${state}`,
        look ? `agent-face--toned agent-face--tone-${look.tone}` : '',
    ].filter(Boolean).join(' ');

    const top = look?.top ?? 'mast';
    const ears = look?.ears ?? true;
    const bulbY = top === 'crown' ? 4 : top === 'none' ? 10 : 5;

    return (
        <svg
            className={className}
            viewBox="0 0 48 48" width={size} height={size}
            role="img" aria-label={title || 'Agente'}
        >
            {title && <title>{title}</title>}

            {top === 'mast' && (
                <line className="agent-face__mast" x1="24" y1="7" x2="24" y2="13" />
            )}
            {top === 'crown' && (
                <path className="agent-face__trim" d="M13 14 L15 6 L20 11 L24 8 L28 11 L33 6 L35 14" />
            )}
            <circle className="agent-face__bulb" cx="24" cy={bulbY} r={top === 'none' ? 2.5 : 3} />

            {/* The side stubs read as hardware and keep the head from looking
                like a speech bubble. */}
            {ears && (
                <>
                    <path className="agent-face__stub" d="M9 24 H5 v6 h4" />
                    <path className="agent-face__stub" d="M39 24 h4 v6 h-4" />
                </>
            )}

            <rect
                className="agent-face__head"
                x="9" y="13" width="30" height="26"
                rx={look?.head === 'square' ? 3 : 9}
            />

            {look?.brow && (
                <path className="agent-face__trim" d="M14 20 L21 21 M34 20 L27 21" />
            )}

            <circle className="agent-face__eye" cx="18" cy="25" r="3.2" />
            <circle className="agent-face__eye" cx="30" cy="25" r="3.2" />

            {look?.prompt && (
                <path className="agent-face__trim" d="M12 31.5 L14.5 33.5 L12 35.5" />
            )}

            <rect className="agent-face__cell agent-face__cell--1" x="16" y="32" width="4" height="3" rx="1.5" />
            <rect className="agent-face__cell agent-face__cell--2" x="22" y="32" width="4" height="3" rx="1.5" />
            <rect className="agent-face__cell agent-face__cell--3" x="28" y="32" width="4" height="3" rx="1.5" />
        </svg>
    );
}
